module.exports = " <div :class=\"[ 'svg-icon', { 'using-div': type === 'div', 'using-svg': type === 'svg' } ]\" v-html=html></div> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/statamic/resources/js/components/SvgIcon.vue
// module id = 487
// module chunks = 0